import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Family Counseling Associates of New Hampshire theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const FCAOFNH_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/fcaofnh/logo.png",
        alt: "Family Counseling Associates of New Hampshire Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 23,
  state: "NH",
  departmentIds: [153, 159, 170],
};
